'use client';

import { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import MaintenanceSvg from '@/context/global/assets/MaintenanceSvg';
import CWButton from '@/context/global/components/g00/g00-d00-g006-cw-button';

interface MaintenanceProviderProps {
  children: ReactNode;
}

export default function MaintenanceProvider({ children }: MaintenanceProviderProps) {
  const t = useTranslations('Maintenance');
  const isMaintenance = process.env.NEXT_PUBLIC_IS_MAINTENANCE === 'true';

  if (isMaintenance) {
    return (
      <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#030606]">
        <div className="flex flex-col items-center gap-6">
          <MaintenanceSvg className="h-[123px] w-[152px]" />

          <div className="flex flex-col items-center gap-2">
            <h1 className="text-center text-2xl font-medium text-white md:text-[30px]">
              {t('title')}
            </h1>
            <p className="max-w-[500px] text-center text-sm text-white/80 md:text-base">
              {t('description')}
            </p>
          </div>

          <CWButton
            title={t('ok')}
            variant="dark"
            outline
            onClick={() => window.location.reload()}
            className="h-[50px] w-[150px] border-2 border-white text-lg font-medium text-white md:h-[56px] md:w-[180px] md:text-xl"
            parentClassname="w-[150px] md:w-[180px]"
          />
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
